import { render, staticRenderFns } from "./knowledge.vue?vue&type=template&id=6bedea62&scoped=true"
import script from "./knowledge.vue?vue&type=script&lang=js"
export * from "./knowledge.vue?vue&type=script&lang=js"
import style0 from "./knowledge.vue?vue&type=style&index=0&id=6bedea62&prod&lang=scss&scoped=true"
import style1 from "./knowledge.vue?vue&type=style&index=1&id=6bedea62&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bedea62",
  null
  
)

export default component.exports